export default __webpack_public_path__ + "static/media/Logo_ST_.8d1a6e55.png";